

























































import {Vue, Component, Ref, Watch} from 'vue-property-decorator';
import dataService from '@/services/data-proxy.service'
import storage from "@/services/local-storage.service";
import {TabBase} from "@/views/Vozila/DetaljiVozila/TabBase";

@Component
export default class Tab6 extends TabBase {
    PING_INTERVAL = 300 * 1000;
    @Ref('map') map: any;
    handler;
    mapStyle = {};
    zoom = 8;
    center = [19.881415099999998, 45.250867];
    position: {} = null;
    popoverPosition = [0, 0];
    selectedMarker = {dodatniPodaci: {}};

    selectOptionsInterval = [];
    selectedOptionInterval: any = 5;
    automatskoOsvezavanje: any = false;
    timer;

    baseLayers: [
        {
            name: 'osm',
            title: 'OpenStreetMap',
            visible: true,
        },
        {
            name: 'sputnik',
            title: 'Sputnik Maps',
            visible: false,
        }
    ];

    created() {
        this.getPositions();
        this.handler = setInterval(this.getPositions, this.PING_INTERVAL);
        this.selectOptionsInterval = [
            {value: 1, text: `${1} ${this.$i18n.t('min')}`},
            {value: 5, text: `${5} ${this.$i18n.t('min')}`},
            {value: 10, text: `${10} ${this.$i18n.t('min')}`},
            {value: 30, text: `${30} ${this.$i18n.t('min')}`},
            {value: 50, text: `${50} ${this.$i18n.t('min')}`},
            {value: 75, text: `${75} ${this.$i18n.t('min')}`}
        ];
        this.automatskoOsvezavanje = storage.get('automatskoOsvezavanjeGpsVozilo') ? storage.get('automatskoOsvezavanjeGpsVozilo') : false;
        this.selectedOptionInterval = storage.get('intervalGpsVozilo') ? storage.get('intervalGpsVozilo') : 5;
    }

    mounted() {
        this.mapStyle = {height: `${window.innerHeight - 200}px`};
    }

    async getPositions() {
        const pozicijeVozila = await this.loadData(() => dataService.vratiPozicijeVozila())();
        const pozicijaVozila = pozicijeVozila.find(x => x.voziloId == this.vozilo.id);
        if (pozicijaVozila) {
            this.position = {...pozicijaVozila, position: [pozicijaVozila.longituda, pozicijaVozila.latituda]};
            this.map.refresh();
        }
    }

    mapClick(e) {
        let found = false;
        e.map.forEachFeatureAtPixel(e.pixel, (feature) => {
            this.selectedMarker = feature.values_;
            this.popoverPosition = feature.values_.position;
            found = true;
            return found;
        });
        if (!found) {
            this.selectedMarker = {dodatniPodaci: {}};
            this.popoverPosition = [0, 0];
        }
    }

    async osveziPoziciju() {
        const pozicijeVozila = await this.loadData(() => dataService.vratiPozicijeVozila())();
        const pozicijaVozila = pozicijeVozila.find(x => x.voziloId == this.vozilo.id);
        if (pozicijaVozila) {
           try {
               this.position = {...pozicijaVozila, position: [pozicijaVozila.longituda, pozicijaVozila.latituda]};
               this.map.refresh();
               this.showInfo('pozicije su osvezene')
           } catch (e) {

           }
        }
    }


    @Watch('automatskoOsvezavanje')
    @Watch('selectedOptionInterval') onSelectedOptionIntervalChange() {
        clearInterval(this.timer);
        if (this.automatskoOsvezavanje) {
            this.timer = setInterval(async () => {
                this.osveziPoziciju();
            }, this.selectedOptionInterval * 60000);
        } else {
            clearInterval(this.timer)
        }
    }

    @Watch('automatskoOsvezavanje') onAutomatskoOsvezavanjeChange(value) {
        storage.add('automatskoOsvezavanjeGpsVozilo', value);
    }

    @Watch('selectedOptionInterval') onIntervalChange(value) {
        storage.add('intervalGpsVozilo', value);
    }

    destroyed() {
        if (this.handler) {
            clearInterval(this.handler);
        }
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
}
